export const workspaceKey_ContextRulesSearch = 'workspace-key-context-rules-search';
export const WorkspaceConfig_ContextRulesSearch = {
    name: 'context-rules-search',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'searchPanel', visible: true, factor: 1.5 / 5, min: 500,
                data: {}
            },
            {
                name: 'RightPanel', key: 'dataViewer', visible: true, factor: 3.5 / 5, min: 500,
                data: {}
            },
        ]
    }
};
//# sourceMappingURL=workspace-config.js.map